import { useEffect } from "react";

const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.deeniyat.duaforprotection&hl=hi";
const IOS_URL =
  "https://apps.apple.com/in/app/hifazat-ki-dua/id1104742571";

function getRedirectUrl() {
  const userAgent = navigator.userAgent || window.opera;
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return IOS_URL;
  }
  return ANDROID_URL;
}

function HifazatKiDuaRedirect() {
  useEffect(() => {
    window.location.href = getRedirectUrl();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        fontFamily: "sans-serif",
      }}
    >
      <p>Redirecting to Hifazat Ki Dua app...</p>
      <p style={{ fontSize: "12px", color: "#888" }}>
        If you are not redirected,{" "}
        <a href={getRedirectUrl()}>click here</a>.
      </p>
    </div>
  );
}

export default HifazatKiDuaRedirect;
